var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.75,4.28c-2.16,0-3.92,1.75-3.92,3.91s1.75,3.92,3.91,3.92,3.92-1.75,3.92-3.91h0c0-2.16-1.75-3.91-3.91-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.49,18.4v-1.01c0-2.44-1.97-4.41-4.41-4.42h-4.66c-2.44,0-4.41,1.98-4.41,4.41v1.01c0,.73.59,1.33,1.33,1.33h10.84c.73,0,1.32-.6,1.32-1.33h-.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.94,10.72v.49c0,.24-.19.43-.43.43h-1.61v1.61c0,.24-.19.43-.43.43h-.49c-.24,0-.43-.19-.43-.43v-1.61h-1.61c-.24,0-.43-.19-.43-.43v-.49c0-.24.19-.43.43-.43h1.61v-1.61c0-.24.19-.43.43-.43h.49c.24,0,.43.19.43.43v1.61h1.61c.24,0,.43.19.43.43Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCustomer);
export default __webpack_public_path__ + "static/media/Add Customer.4164994a7c72c79a1df6d183e9dcab94.svg";
export { ForwardRef as ReactComponent };